var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreditCardIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1H1c-.6 0-1 .4-1 1s.4 1 1 1h1v11c0 .6.4 1 1 1h6V3h2v12h2c.6 0 1-.4 1-1V3h1c.6 0 1-.4 1-1s-.4-1-1-1zM6 13H5v-2h1v2zm0-8H5V3h1v2z",
    fill: "#797584"
  })));
}

export default SvgCreditCardIn;